import {
    getDataWithParams,
    destroyData,
    postData,
    getAllData,
    downloadFile
} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    name: null,
    weight: null,
    semester_id: null,
    semester_name: null,
    type: null,
    category_id: null,
    field_id: null,
    field_name: null,
    field_type: null,
    field_weight: null,
    result_id: null,
    temp_value: null,
    grade: null,
    result: null
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "ASC",
    search: null,
    filter: null
}
const initialState = () => ({
    data: {},
    rubricForm: [],
    msg: "Jaringan Bermasalah",
    status: 0,
    request: {...requestInit},
    item: {...itemInit},
    kategoriStatus: [
        {
            status: 0,
            label: "Tidak Aktif",
            type: "danger"
        },
        {
            status: 1,
            label: "Aktif",
            type: "success"
        }
    ],
    blobData: null,
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    getKategoriStatus: state => (status) => state.kategoriStatus.find(x => x.status == status),
    getRubricForm: state => (type) => state.rubricForm[type] || [],
    getBlobData: state => state.blobData
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.msg
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    SET_RUBRIC_FORM(state, {value, type}) {
        state.rubricForm[type] = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

const actions = {
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',value)
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    async getRubricResult({commit }, {id, type}) {
        try {
            const url = `/research-nilai/${type}/${id}`
            var response = await getAllData(url);
            commit('SET_RESPONSE', response.data)
            commit('SET_RUBRIC_FORM', {value: response.data.data, type: type});
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async submit({commit }, data) {
        try {
            var response = await postData('/research-nilai',data);
            commit('SET_RESPONSE', response.data);
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAllDataCategory({commit, state}) {
        try {
            const response = await getDataWithParams('/research-rubric', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async storeCategory({commit }, data) {
        try {
            const response = await postData('/research-rubric', data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async updateCategory({commit }, data) {
        try {
            const url = `/research-rubric/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async updateStatusCategory({commit }, data) {
        try {
            const url = `/research-rubric/status/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async deleteDataCategory({commit }, id) {
        try {
            const url = `/research-rubric/${id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAllDataField({commit, state}, id) {
        try {
            const url = `/research-field/${id}`
            const response = await getDataWithParams(url, state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async storeField({commit }, {id, data}) {
        try {
            const url = `/research-field/${id}`
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async updateField({commit }, data) {
        try {
            const url = `/research-field/update/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async updateStatusField({commit }, data) {
        try {
            const url = `/research-field/status/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async deleteDataField({commit }, id) {
        try {
            const url = `/research-field/${id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async downloadFile({commit }, {item, type}) 
    {
        try {
            const url = `/research-nilai/export/${item.result_id}`
            const payload = {
                ...item
            }
            delete payload.id
            var response = await downloadFile(url);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
